
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { PlotExpenseTable } from "./PlotExpenseTable";
import { ScrollArea } from "@/components/ui/scroll-area";

interface PlotExpenseWithCategory {
  id: string;
  amount: number;
  description: string | null;
  expense_date: string;
  receipt_url: string | null;
  expense_categories: {
    name: string;
  };
}

interface PlotExpenseListProps {
  expenses: Array<PlotExpenseWithCategory>;
}

export const PlotExpenseList = ({ expenses }: PlotExpenseListProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter expenses based on search term
  const filteredExpenses = expenses.filter(expense =>
    expense.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    expense.expense_categories.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Group expenses by month and calculate totals
  const groupedExpenses = filteredExpenses.reduce((groups, expense) => {
    const date = new Date(expense.expense_date);
    const monthYear = format(date, 'MMMM yyyy', { locale: es });
    
    if (!groups[monthYear]) {
      groups[monthYear] = {
        expenses: [],
        total: 0
      };
    }
    groups[monthYear].expenses.push(expense);
    groups[monthYear].total += expense.amount;
    return groups;
  }, {} as Record<string, { expenses: typeof expenses, total: number }>);

  return (
    <Card className="h-[calc(100vh-16rem)]">
      <CardContent>
        <div className="mt-6 mb-4">
          <Input
            placeholder="Buscar gastos de parcela..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="max-w-sm"
          />
        </div>
        <ScrollArea className="h-[calc(100vh-24rem)] pr-4">
          {Object.entries(groupedExpenses).length > 0 ? (
            Object.entries(groupedExpenses).map(([monthYear, { expenses: monthExpenses, total }]) => (
              <div key={monthYear} className="mb-8">
                <div className="flex justify-between items-center mb-4 sticky top-0 bg-background py-2">
                  <h3 className="text-lg font-semibold capitalize">{monthYear}</h3>
                  <span className="text-lg font-semibold">
                    Total: ${total.toLocaleString('es-ES', { maximumFractionDigits: 0 }).replace(/,/g, '.')}
                  </span>
                </div>
                <PlotExpenseTable expenses={monthExpenses} />
              </div>
            ))
          ) : (
            <div className="text-center py-8 text-muted-foreground">
              No hay gastos para mostrar
            </div>
          )}
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
